/* eslint-disable */
import { Card } from '@/components/elements/cards';
import PageViewLayout from '@/components/layouts/PageViewLayout/PageViewLayout';
import Breadcrumbs from '@/components/modules/breadcrumbs/Breadcrumbs';
import Navigation from '@/components/modules/pages/support/Navigation';
import { RandomSupportFaq } from '@/components/modules/pages/support/RandomSupportFaq';
import SEO from '@/components/modules/SEO';
import { SCREEN_NAME } from '@/constants/analytics';
import { isMobile, isServer, isSistaminuten, trackPage, url } from '@/helpers';
import { getSupportFaq } from '@/helpers/faq';
import { trackScreenShown } from '@/hooks/useTrackScreenShown';
import { _t } from '@/locale';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import '@/styles/pages/articles/_support.scss';

const Support = () => {
  useEffect(() => {
    if (isServer) return;
    window.scrollTo(0, 0);
    trackPage();
    trackScreenShown({ screen_name: SCREEN_NAME.SUPPORT });
    sessionStorage.removeItem('bd_sf');
  }, []);

  return (
    <PageViewLayout title="" type="mainView" wrapperClass="bg-gradient">
      <Breadcrumbs
        className="hidden px-4 py-2 text-sm sm:block sm:px-10"
        items={[
          { title: _t('Start'), url: '/' },
          { title: _t('support'), url: '/support' },
        ]}
      />
      <div
        className="h-[170px] w-auto bg-cover bg-center bg-no-repeat lg:h-[300px]"
        style={{ backgroundImage: `url(/images/hero-support.jpg)` }}>
        <div className="container mx-auto flex h-full items-center justify-center">
          <h1 className="text-lg font-bold uppercase text-white lg:text-5xl">{_t('support')}</h1>
        </div>
      </div>
      <div className="bg-gradient pb-12">
        <div className="container pt-6">
          <div className="mb-lg">
            <h3 className="mb-1 text-lg font-bold lg:text-4xl">
              {_t(isMobile() ? 'supportPage.helpCategories' : 'supportPage.faqLong')}
            </h3>
            <span className="text-black-600 text-sm lg:text-2xl">{_t('supportPage.regardingYourCase')}</span>
          </div>
          <div className="gap-lg hidden grid-flow-row-dense grid-cols-[repeat(auto-fill,minmax(312px,1fr))] sm:grid">
            {getSupportFaq().map((section, key) => (
              <div key={key} className="flex flex-1">
                <Card
                  style={{ margin: 0 }}
                  className="text-black-900 tracking-content flex flex-1 flex-col bg-white text-base">
                  <h3 className="splitter flex items-center justify-start gap-x-4 text-2xl tracking-normal">
                    <section.icon className="h-5" />
                    {section.title}
                  </h3>
                  {section.questions.slice(0, 3).map((q, i) => {
                    return (
                      <Link
                        to={{ pathname: section.path, state: { active: q.id } }}
                        className="text-black-900 mb-4"
                        key={i}>
                        {q.question}
                      </Link>
                    );
                  })}
                  <div className="h-8"></div>
                  <Link className="text-black-900 mt-auto text-lg font-bold" to={section.path}>
                    {_t('supportPage.viewAll')}
                  </Link>
                </Card>
              </div>
            ))}
          </div>
          <div className="sm:hidden">
            <Navigation />
          </div>
          <div className="mb-10 mt-6 hidden h-[1px] bg-white sm:block"></div>
          <RandomSupportFaq />
        </div>
      </div>
      <SEO
        title={_t('seo.helpTitle')}
        description={_t('seo.helpDescription')}
        url={`${url.getBaseUrl()}support`}
        image={url.getBaseImageUrl()}>
        {isSistaminuten() && <meta name="robots" content="noindex" />}
      </SEO>
    </PageViewLayout>
  );
};

export default Support;
